var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FAE9E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12536_111459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 16C22.2696 16 16 22.2696 16 30C16 37.7304 22.2696 44 30 44C37.7304 44 44 37.7304 44 30C44 22.2696 37.7304 16 30 16ZM30 41.5652C23.6087 41.5652 18.4348 36.3913 18.4348 30C18.4348 23.6087 23.6087 18.4348 30 18.4348C36.3913 18.4348 41.5652 23.6087 41.5652 30C41.5652 36.3913 36.3913 41.5652 30 41.5652ZM34.6565 32.9217C35.1435 33.4087 35.1435 34.1696 34.6565 34.6565C34.413 34.9 34.1087 35.0217 33.8043 35.0217C33.5 35.0217 33.1957 34.9 32.9522 34.6565L29.1478 30.8522C28.9043 30.6391 28.7826 30.3348 28.7826 30V22.7565C28.7826 22.087 29.3304 21.5391 30 21.5391C30.6696 21.5391 31.2174 22.087 31.2174 22.7565V29.513L34.6565 32.9217Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12536_111459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.97c5592aa9f48ad7624f8e9591edd06a.svg";
export { ForwardRef as ReactComponent };